module.exports = __webpack_public_path__ + "img/mapaIcon.a644b69f.png";